import type { GetLocalitesQueryResponse } from '~/api/gen'
import { http, HttpResponse } from 'msw'
import { localites } from '~/msw/mocks/localite/localites'

export function getLocalitesHandler() {
  return http.get<never, never, GetLocalitesQueryResponse>('http://localhost:3000/api/v1/localites', ({ request }) => {
    const search = (new URL(request.url).searchParams.get('search') ?? '').toLowerCase()
    if (!search.trim())
      return HttpResponse.json([])

    const matches = localites.filter(localite =>
      localite.nom.toLowerCase().includes(search) || localite.codePostal.includes(search),
    )
    return HttpResponse.json(matches)
  })
}
